export default {
  data() {
    return {
      sortingSelect: [
        {
          text: this.$t('mixins.filterListMixin.agmVisionPresents'),
          value: 'agmVisionPresents',
        },
        {
          text: this.$t('mixins.filterListMixin.popularity'),
          value: '-popular',
        },
        {
          text: this.$t('mixins.filterListMixin.newItems'),
          value: 'newest',
        },
        {
          text: this.$t('mixins.filterListMixin.bestRatings'),
          value: 'bestRated',
        },
        {
          text: this.$t('mixins.filterListMixin.promotions'),
          value: 'discounts',
        },
        {
          text: this.$t('mixins.filterListMixin.priceAscending'),
          value: 'prices',
        },
        {
          text: this.$t('mixins.filterListMixin.priceDescending'),
          value: '-prices',
        },
      ],
    }
  },
}
